import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/commonHelper/AppConsts';

@Injectable()
export class AppAuthService {

    logout(reload?: boolean, returnUrl?: string): void {
        abp.auth.clearToken();
        let tokenExpireDate = new Date(new Date().getTime() + 1000 * 1);
        abp.utils.setCookieValue(abp.auth.tokenCookieName, '', tokenExpireDate, abp.appPath, undefined, { sameSite: 'none', secure: true });
        abp.utils.setCookieValue(AppConsts.authorization.encrptedAuthTokenName, '', tokenExpireDate, abp.appPath, undefined, { sameSite: 'none', secure: true });

        if (reload !== false) {
            if (returnUrl) {
                location.href = returnUrl;
            } else {
                location.href = AppConsts.appBaseUrl;
            }
        }
    }
}
